/**
 * @description 获取应用配置类
 * @author zhijie.huang
 * @date 2018/9/11
 */
import { getInstance } from '../utils/tool'
class GlobalConfig {
  static getConfig() {
    return new Promise((resolve, reject) => {
      const http = new XMLHttpRequest() // eslint-disable-line
      http.open('get', '/app-config.json')
      http.onreadystatechange = () => {
        if (http.readyState === XMLHttpRequest.DONE) {
          if (http.status === 200 || http.status === 304) {
            const data = JSON.parse(http.responseText)
            resolve(data)
          } else {
            console.warn('GlobalConfig Error: get app-config.json fail', http.statusText)
            reject(http.responseText)
          }
        }
      }
      http.send()
    })
  }

  static getInstance = getInstance((data) => new GlobalConfig(data)); // eslint-disable-line

  constructor(data) {
    this.data = data
  }
}
export default GlobalConfig
